import { makeCatalogEvent, prependCatalogName } from '@dashboard/junk-drawer/utils/eventstream';
const CATALOG_NAME = 'feedback_survey';
export function feedbackSurveyEvent(metadata = {}) {
  return makeCatalogEvent(CATALOG_NAME, prependCatalogName({
    action: metadata.action,
    description: metadata.description,
    survey_token: metadata.surveyToken,
    question_token: metadata.questionToken
  }, CATALOG_NAME));
}
export function surveyRendered(surveyToken) {
  return feedbackSurveyEvent({
    action: 'view',
    description: 'Survey Rendered',
    surveyToken
  });
}
export function surveyDismissed(surveyToken) {
  return feedbackSurveyEvent({
    action: 'click',
    description: 'Survey Dismissed',
    surveyToken
  });
}
export function surveyCompleted(surveyToken) {
  return feedbackSurveyEvent({
    action: 'click',
    description: 'Survey Completed',
    surveyToken
  });
}
export function surveyQuestionAnswered(surveyToken, questionToken) {
  // track question token?
  return feedbackSurveyEvent({
    action: 'click',
    description: 'Question Answered',
    surveyToken,
    questionToken
  });
}